<template>
    <v-row class="table_content-type-selector px-2 pb-0">
        <v-col cols="auto" class="py-1">
            <v-select
                :label="$t('ContentType')"
                :items="contentTypes"
                item-text="text"
                item-value="id"
                v-model="contentType"
                hide-details
            />
        </v-col>
    </v-row>
</template>

<script>
import { EventBus } from '@/eventBus.js';

export default {
    name: 'DocumentTableContentTypeSelector',
    props: {
        contentTypes: {
            type: Array,
            default: () => []
        },
        prevSelectedContentType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            contentType: this.prevSelectedContentType,
        };
    },
    mounted() {
        if (this.contentTypes.length > 0) {
            if (this.prevSelectedContentType) {
                this.contentType = this.prevSelectedContentType;
            } else {
                this.contentType = this.contentTypes[0].id;
            }
            this.updateContentType(this.contentType);
        }
    },
    methods: {
        updateContentType(value) {
            EventBus.$emit('content-type-changed', value);
        },
    },
    watch: {
        contentType(value, oldValue) {
            if (value === oldValue) return;
            this.updateContentType(value);
        }
    }
};
</script>
<style lang="scss" scoped>
.row {
    width: 100%;
}
</style>